module.exports = __webpack_public_path__ + "img/log-out.4edae1de.svg";